import styled from "styled-components";
import { transition } from "@evergis/ui";

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const SettingToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const VerticalContainer = styled.span<{ show?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 0;

  max-height: ${({ show }) => `${show ? 750 : 0}px`};
  opacity: ${({ show }) => +show};
  transition: ${transition.show} 0s;
  transition-property: max-height, opacity;
  overflow: hidden;

  > * {
    flex-shrink: 0;
  }
`;
